import type React from 'react'

import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  title: string
}

export const SettingCard: React.FC<Props> = ({ title, children }) => (
  <div className={css.setting_card}>
    <div className={css.setting_card_title}>{title}</div>
    <div className={css.setting_card_wrap}>{children}</div>
  </div>
)
